Object.defineProperty(exports,"__esModule",{value:true});exports.default=



{
warn:function warn(message){
if(process.env.NODE_ENV!=="production"){
if(console&&console.warn){
console.warn(message);
}
}
}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-util/log.js
// module id = 624
// module chunks = 0